<template>

    <div :class="['filterElement', { 'is-activated': filter.isActive }]" v-if="filter.show != false">

        <div class="filterActivator" @click="setFilterStatus()">
            <i class="icon-ak-filter"></i>
        </div>

        <!-- DEFAULT -->
        <template v-if="filter.type == 'default'">

            <div v-for="option in filter.options" :key="option.id" :class="['option', { 'selected': option.selected }]" @click="changeFilterOption(option)">
                <div>
                    {{ typeof option.displayName != 'undefined' ? option.displayName : option.name }}
                </div>
            </div>

        </template>

        <!-- DATE -->
        <template v-else-if="filter.type == 'date'">

            <div class="option date-picker" :id="id">
                <lang class="label" :labelKey="'PIM-FILTER-LABEL-'+ filter.label.toUpperCase()"></lang>
                <datepicker placeholder="von" :options="datePickerOptions" v-model="filter.options.date1"></datepicker>
                <datepicker placeholder="bis" :options="datePickerOptions" v-model="filter.options.date2"></datepicker>
            </div>

        </template>

        <!-- CATEGORY -->
        <template v-else-if="filter.type == 'category'">

            <div class="option selector" @click="changeFilterSelector('category')">

                <treeselect
                    v-model="filter.options"
                    placeholder="bitte Kategorie(n) auswählen"
                    :multiple="true"
                    :loading="optionsLoading"
                    :options="options"
                    :normalizer="normalizer"
                    value-consists-of="ALL">
                </treeselect>

            </div>
        </template>

           <!-- brand -->
        <template v-else-if="filter.type == 'brand'">

            <div class="option selector" @click="changeFilterSelector('brand')">

                <treeselect
                    v-model="filter.options"
                    placeholder="bitte Brand auswählen"
                    :multiple="true"
                    :loading="optionsLoading"
                    :options="brandOptions"
                    :normalizer="normalizer"
                    value-consists-of="ALL">
                </treeselect>

            </div>

        </template>

        <!-- DROPDOWN -->
        <template v-else-if="filter.type == 'dropdown'">

            <div class="option dropdown" @click="changeFilterSelector">

                <!-- <pre>{{ filter.options }}</pre> -->

                <form-input :style="!filter.isActive ? 'pointer-events: none;' : ''"
                    v-model="filter.options"
                    inputType="select"
                    :showLabel="false"
                    :label="'PIM-SELECT_'+filter.label.toUpperCase()"
                    :custom-label="customLabel"
                    :loading="optionsLoading"
                    :selectFieldName="filter.selectFieldName"
                    :selectIsSearchable="true"
                    :selectAllowEmpty="true"
                    :selectOptions="options"
                    :showLabelInOptions="false"
                    @select="onDropdownSelect" :key="options">
                </form-input>
                <!--
                @open="onDropdownOpen"
                @select="onDropdownSelect"
            -->

            </div>

        </template>
    </div>


</template>



<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import { de } from 'flatpickr/dist/l10n/de';

export default {

    components: { Treeselect },

    props: {

        filter: {
            type: Object,
            required: true
        },

    },

    data() {

        return {
            options: null,
            brandOptions: null,
            optionsLoading: false,

            datePickerOptions: {
                enableTime: false,
                altInput: true,
                altFormat: 'd.m.Y',
                locale: de,
				clickOpens: true,
                weekNumbers: false
            },

            id: 0

        }

    },

    watch: {

        "filter.isActive"(newVal, oldVal) {

            if(newVal === false) {
                this.deactivateFilter();
            }

        },

        "filter.options"(val) {

            if(this.filter.type == 'category') {
                this.filter.isActive = val != null && val.length > 0;
            }

            else if(this.filter.type == 'dropdown') {
                // console.log("val: ", val);
                this.filter.isActive = val != null;
            }

        },

        "filter.options.date1"(val) {

            if(val == "" && this.filter.options.date2 == "") {
                this.filter.isActive = false;
            } else {
                this.filter.isActive = true;
            }
        },

        "filter.options.date2"(val) {

            if(val == "" && this.filter.options.date1 == "") {
                this.filter.isActive = false;
            } else {
                this.filter.isActive = true;
            }

        }

    },


    created() {

        if(this.filter.type == 'date') {
            this.id = 'flat-'+Math.floor(Math.random() * (9999 - 1 + 1)) + 1;
        }
    },

    mounted() {

    },

    methods: {

        customLabel({ name, displayName }) {

            console.log("name: ", displayName);
            if(typeof displayName != 'undefined') {
                return displayName;
            } else {
                return name;
            }

        },

        onDropdownOpen() {

            if(this.filter.isActive) {
                this.filter.isActive = true;
            }

            if(this.options == null) {
                this.setFilterStatus();
            }

        },

        deactivateFilter() {

            this.setFilterStatus(true);

        },

        setFilterStatus(deactivate=false) {

            if(!deactivate) {
                this.filter.isActive = !this.filter.isActive;
            }

            // default filters
            if(this.filter.type == 'default') {

                // if there was only one option, we automatically active it upon filter activation
                if(this.filter.options.length == 1) {
                    this.filter.options[0].selected = true;
                }

                // deselect all filter options upon filter deactivation
                if(!this.filter.isActive) {
                    this.filter.options.forEach(option => option.selected = false);
                }

            }

            // date filter
            else if(this.filter.type == 'date') {

                if(this.filter.isActive == false) {

                    let matches = document.getElementById(this.id).querySelectorAll('.flatpickr-input');
                    if(matches.length > 0) {
                        matches.forEach(_ => _._flatpickr.clear() );
                    }

                }

            // category filter
            } else if(this.filter.type == 'category' || this.filter.type == 'dropdown') {

                if(this.filter.isActive && this.options == null) {
                    this.loadOptions();
                }

                else if(!this.filter.isActive) {
                    this.filter.options = null;
                }

            }
            else if(this.filter.type == 'brand' || this.filter.type == 'dropdown') {
                if(this.filter.isActive && this.options == null) {
                    this.loadBrandOptions();
                }

                else if(!this.filter.isActive) {
                    this.filter.options = null;
                }

            }

        },

        changeFilterOption(option) {

            if(!this.filter.isActive && !option.selected) {

                this.filter.isActive = true;
                option.selected = true;

            }
            else if(this.filter.isActive && option.selected) {

                this.filter.isActive = false;
                this.filter.options.forEach(option => option.selected = false);

            }
            else {

                this.filter.options.forEach(option => option.selected = false);
                option.selected = true;

            }

        },

        changeFilterSelector(val) {

            if(this.options == null) {
                if(val==='brand') {
                    this.loadBrandOptions();
                }
                else
                this.loadOptions();

            } else {

                this.filter.isActive = true;
                // this.filter.isActive = !this.filter.isActive;
                return false;

            }

        },

        loadOptions() {

            if(typeof this.filter.selectOptions != 'undefined' && this.filter.selectOptions.length > 0) {

                this.options =  this.filter.selectOptions;
                this.filter.isActive = true;

            } else {

                this.optionsLoading = true;

                this.axios.get(this.$config.api + this.filter.api)
                    .then(res => {

                        if(res.data.user) {
                            this.options = res.data.user;
                        } else {
                            this.options = res.data;
                        }

                        this.optionsLoading = false;
                        this.filter.isActive = true;

                    })

            }

        },


        loadBrandOptions() {

            if(typeof this.filter.selectOptions != 'undefined' && this.filter.selectOptions.length > 0) {

                this.brandOptions =  this.filter.selectOptions;
                this.filter.isActive = true;
            } else {

                this.optionsLoading = true;
                this.axios.get(this.$config.api + 'pimBrand?orderBy=name&filters[name]=!')
                    .then(res => {

                        if(res.data) {
                            this.brandOptions = res.data.pimBrand;
                        } else {
                            this.brandOptions = res.data;
                        }

                        this.optionsLoading = false;
                        this.filter.isActive = true;

                    })

            }

        },

        normalizer(node) {

            return {
                id: node.id,
                label: node.name,
                children: node.children
            }

        }

    }

}

</script>



<style lang="scss" scoped>

    @import '~../../assets/css/variables.scss';

    .filterElement {
        position: relative;
        background: #e5e5e5;
        display: flex;

        margin: 0 6px 5px 0;
        padding: 0;
        min-height: 26px;

        border-radius: 2px;

        > .filterActivator {
            background-color: #c5c5c5;
            color: #999;
            font-size: 12px;
            width: 24px;
            min-width: 24px;
            line-height: 100%;

            border-bottom-left-radius: 2px;
            border-top-left-radius: 2px;
            cursor: pointer;
            transition: all .2s ease;

            display: flex;
            justify-content: center;
            align-items: center;

            &:hover {
                background-color: #ccc;
                color: #222;
            }

        }

        > .option {
            text-align: center;
            font-size: 11px;
            cursor: pointer;
            transition: all .2s ease;
            /*pointer-events: none;*/
            color: #999;
            min-width: 80px;

            > div {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                padding: 0 8px;
            }

            &:hover {
                background-color: #ccc !important;
            }

            &.selected {
                background-color: $themeColor1 !important;
                color: white !important;
            }

            &:last-child {
                border-bottom-right-radius: 2px;
                border-top-right-radius: 2px;

                > div {
                    border-bottom-right-radius: 2px;
                    border-top-right-radius: 2px;
                }
            }

            &:not(:last-child) {
                border-right: .5px solid #ddd;
            }

            &.selector {
                max-width: 400px;
                min-width: 400px;
                padding: 0;

                &:hover {
                    background: inherit !important;
                }

                > div {
                    padding: 0;
                    text-align: left;
                }

                ::v-deep .vue-treeselect__control {
                    border-radius: 0;
                    background-color: transparent;
                    outline: none !important;
                    border: none;
                    height: 26px;

                    .vue-treeselect__multi-value-item-container {
                        padding-top: 2px;
                    }
                    .vue-treeselect--has-value,
                    .vue-treeselect__multi-value {
                        margin-bottom: 2px;

                        .vue-treeselect__multi-value-item  {
                            padding: 2px 0;
                            font-size: 10px;

                            .vue-treeselect__value-remove > svg {
                                width: 4px;
                                height: 4px;
                            }
                        }

                        .vue-treeselect__input-container {
                            padding-top: 2px;
                            font-size: 10px;
                        }
                    }
                    .vue-treeselect__placeholder,
                    .vue-treeselect__single-value {
                        line-height: 26px;

                    }
                }

            }

            &.date-picker {

                display: flex;
                padding: 0;
                max-width: auto;
                align-items: center;

                .label {
                    color: #999;
                    display: flex;
                    align-items: center;
                    align-self: stretch;
                    padding: 0 8px;
                    margin: 0;
                    font-weight: normal;

                    &:after {
                        content: ":";

                    }
                }


                ::v-deep .datepicker {

                    .control {

                        max-width: 100px;

                        input {
                            background-color: transparent !important;
                            border: none !important;
                            height: auto !important;
                            border-radius: 0 !important;
                            font-size: 11px;
                        }

                        i {
                            top: 0 !important;
                        }
                    }

                }

            }

            &.dropdown {

                ::v-deep .control {

                    .control {
                        margin-bottom: 0 !important;
                        height: 100% !important;

                        .singleSelect {

                            min-width: 450px;
                            height: 100%;
                            min-height: auto !important;

                            .multiselect__tags {

                                height: auto !important;
                                min-height: 100% !important;
                                border-radius: 0;
                                border: none !important;
                                background-color: transparent !important;

                                .multiselect__input, .multiselect__single {
                                    font-size: 12px !important;
                                    min-height: auto !important;
                                    background: none !important;
                                    border: none !important;
                                }
                            }

                        }

                    }
                }
            }

        }

        &.is-activated .filterActivator {
            background-color: $themeColor2;
            color: white;
        }
        &.is-activated .option {
            pointer-events: auto;
            background-color: #f1f1f1;
            color: #222;

            .label {
                color: #222;
            }
        }

    }



</style>
